// extracted by mini-css-extract-plugin
module.exports = {"userProfile":"UserProfile_userProfile__6OBST","userIcon":"UserProfile_userIcon__1_Ajh","arrowIcon":"UserProfile_arrowIcon__PSEWj"};